import { render, staticRenderFns } from "./FilterTag.vue?vue&type=template&id=261f72fa&scoped=true"
import script from "./FilterTag.vue?vue&type=script&lang=js"
export * from "./FilterTag.vue?vue&type=script&lang=js"
import style0 from "./FilterTag.vue?vue&type=style&index=0&id=261f72fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261f72fa",
  null
  
)

export default component.exports